// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".card.onboarding-form {\n    min-width: 532px;\n    max-width: 932px;\n    width: 70vw;\n}", ""]);
// Exports
module.exports = exports;
